<mat-accordion>
  <mat-expansion-panel [expanded]="expanded" *ngIf="permissions.includes('view_all_historic')">
    <mat-expansion-panel-header>
      <mat-panel-title style="max-width: 400px;">
        Imports en attente de validation ({{ historicAll.length }})
      </mat-panel-title>
      <mat-panel-description>
        Vérifier les imports en attente de validation pour l'envoi
      </mat-panel-description>
    </mat-expansion-panel-header>

    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value, 'false')" placeholder="Filtrer">
    </mat-form-field>

    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="historicAllMatTable" matSort matSortActive="date" matSortDirection="desc">

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
          <td mat-cell *matCellDef="let element"> {{ element.date | date:'dd/MM/yyyy HH:mm' }} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.status === 1" matBadge="{{element.files.length}}" matBadgePosition="before above" class="status-chip validated">Terminé</span>
            <span *ngIf="element.status === 0" matBadge="{{element.files.length}}" matBadgePosition="before above" class="status-chip waiting">En cours</span>
            <span *ngIf="element.status === 2" matBadge="{{element.files.length}}" matBadgePosition="before above" class="status-chip canceled">Annulé</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="files">
          <th mat-header-cell *matHeaderCellDef> Fichiers </th>
          <td mat-cell *matCellDef="let element"> <span *ngFor="let file of element.files" matTooltip="{{file.morename}}" matTooltipPosition="above" class="file-chip">{{file.name}}</span> </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let element">
            <button color="primary" style="min-width: 48px; padding: 0 8px; margin-right: 8px;" mat-flat-button><mat-icon svgIcon="edit"></mat-icon></button>
            <button color="primary" style="min-width: 48px; padding: 0 8px;" mat-flat-button [disabled]="element.status !== 0"><mat-icon svgIcon="delete"></mat-icon></button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator #PaginatorAll [length]="historicAll.length"
                     [pageSize]="10" showFirstLastButtons></mat-paginator>
    </div>

  </mat-expansion-panel>
  <mat-expansion-panel *ngIf="permissions.includes('view_historic')">
    <mat-expansion-panel-header>
      <mat-panel-title style="max-width: 400px;">
        Historique d'imports ({{ historic.length }})
      </mat-panel-title>
      <mat-panel-description>
        Retrouvez vos précédents imports
      </mat-panel-description>
    </mat-expansion-panel-header>

    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value, 'true')" placeholder="Filtrer">
    </mat-form-field>

    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="historicMatTable" matSort matSortActive="date" matSortDirection="desc">

        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
          <td mat-cell *matCellDef="let element"> {{ element.date | date:'dd/MM/yyyy HH:mm' }} </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut </th>
          <td mat-cell *matCellDef="let element">
            <span *ngIf="element.status === 1" matBadge="{{element.files.length}}" matBadgePosition="before above" class="status-chip validated">Terminé</span>
            <span *ngIf="element.status === 0" matBadge="{{element.files.length}}" matBadgePosition="before above" class="status-chip waiting">En cours</span>
            <span *ngIf="element.status === 2" matBadge="{{element.files.length}}" matBadgePosition="before above" class="status-chip canceled">Annulé</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="files">
          <th mat-header-cell *matHeaderCellDef> Fichiers </th>
          <td mat-cell *matCellDef="let element"> <span *ngFor="let file of element.files" matTooltip="{{file.morename}}" matTooltipPosition="above" class="file-chip">{{file.name}}</span> </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let element">
            <button color="primary" style="min-width: 48px; padding: 0 8px; margin-right: 8px;" mat-flat-button><mat-icon svgIcon="edit"></mat-icon></button>
            <button color="primary" style="min-width: 48px; padding: 0 8px;" mat-flat-button [disabled]="element.status !== 0" (click)="deleteSelfHistoric(element)"><mat-icon svgIcon="delete"></mat-icon></button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator #Paginator [length]="historic.length"
                     [pageSize]="10" showFirstLastButtons></mat-paginator>
    </div>
  </mat-expansion-panel>
</mat-accordion>
